import React, { useState } from 'react';
import { UnifiedInput } from '../../../components/unified';

export default function CompanyAdminForm({ onSubmit, loading }) {
  const [formData, setFormData] = useState({
    fullName: '',
    email: '',
    password: '',
    confirmPassword: '',
    companyName: ''
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e?.target?.name]: e?.target?.value
    });
  };

  const handleSubmit = (e) => {
    e?.preventDefault();
    
    if (formData?.password !== formData?.confirmPassword) {
      alert('Passwords do not match');
      return;
    }

    onSubmit({
      fullName: formData?.fullName,
      email: formData?.email,
      password: formData?.password,
      role: 'company_admin',
      companyName: formData?.companyName
    });
  };

  return (
    <form onSubmit={handleSubmit} className="mt-6 space-y-6">
      <UnifiedInput
        label="Full Name"
        type="text"
        name="fullName"
        value={formData?.fullName}
        onChange={handleChange}
        placeholder="Jane Smith"
        required
        disabled={loading}
      />
      <UnifiedInput
        label="Company Name"
        type="text"
        name="companyName"
        value={formData?.companyName}
        onChange={handleChange}
        placeholder="Your Company Inc."
        required
        disabled={loading}
      />
      <UnifiedInput
        label="Work Email"
        type="email"
        name="email"
        value={formData?.email}
        onChange={handleChange}
        placeholder="you@company.com"
        required
        autoComplete="email"
        disabled={loading}
      />
      <UnifiedInput
        label="Password"
        type="password"
        name="password"
        value={formData?.password}
        onChange={handleChange}
        placeholder="Create a strong password"
        required
        autoComplete="new-password"
        disabled={loading}
      />
      <UnifiedInput
        label="Confirm Password"
        type="password"
        name="confirmPassword"
        value={formData?.confirmPassword}
        onChange={handleChange}
        placeholder="Confirm your password"
        required
        autoComplete="new-password"
        disabled={loading}
      />
      <div className="flex items-center">
        <input
          id="terms"
          name="terms"
          type="checkbox"
          required
          className="h-4 w-4 rounded border-gray-300 text-indigo-600 focus:ring-indigo-600"
        />
        <label htmlFor="terms" className="ml-2 block text-sm text-gray-900">
          I agree to the{' '}
          <a href="#" className="text-indigo-600 hover:text-indigo-500">
            Terms of Service
          </a>{' '}
          and{' '}
          <a href="#" className="text-indigo-600 hover:text-indigo-500">
            Privacy Policy
          </a>
        </label>
      </div>
      <button
        type="submit"
        disabled={loading}
        className="flex w-full justify-center rounded-md bg-indigo-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600 disabled:opacity-50 disabled:cursor-not-allowed"
      >
        {loading ? 'Creating account...' : 'Create company account'}
      </button>
    </form>
  );
}